// removed by extract-text-webpack-plugin
module.exports = {"demoForm":"styles__demoForm___372Hc","submitButton":"styles__submitButton___2shMi","errors":"styles__errors___3zmhN","error":"styles__error___No4dN","warn":"styles__warn___1Rv-a","submitting":"styles__submitting___1x6pi","spinner":"styles__spinner___1mHfH","loadingText":"styles__loadingText___2dE34"};


//////////////////
// WEBPACK FOOTER
// ./src/login-form/styles.scss
// module id = ./src/login-form/styles.scss
// module chunks = 1